import {MutationTree} from 'vuex';
import {AuthorizationState, initialState} from '@/store/modules/authorization';
import {
  AUTHORIZATION_RESET_STATE,
  SET_ACCESS_TOKEN,
  SET_REFRESH_TOKEN,
  SET_REFRESHING_TOKEN,
  SET_TEMPORARY_TOKENS,
  SET_TOKENS,
} from '@/types/authorization.types';

export interface TokensPayload {
  accessToken: string;
  refreshToken: string;
}

export const mutations: MutationTree<AuthorizationState> = {

  [SET_ACCESS_TOKEN]: (state, token: string) => {
    state.accessToken = token;
  },

  [SET_REFRESH_TOKEN]: (state, token: string) => {
    state.refreshToken = token;
  },

  [SET_TOKENS]: (state, tokens: TokensPayload) => {
    state.accessToken = tokens.accessToken;
    state.refreshToken = tokens.refreshToken;
  },

  [SET_TEMPORARY_TOKENS]: (state, tokens: TokensPayload) => {
    state.temporaryAccessToken = tokens.accessToken;
    state.temporaryRefreshToken = tokens.refreshToken;
  },

  [SET_REFRESHING_TOKEN]: (state, refreshingToken: boolean) => {
    state.refreshingToken = refreshingToken;
  },

  [AUTHORIZATION_RESET_STATE]: (state) => {
    state = Object.assign(state, initialState());
  },

};
